<template>
  <nuxt />
</template>

<script>
  // コンテナ稼働監視用ページレイアウト [MCG-634]
  // 「https://tokyoescort-otome.com/gateway」を削除すると本番環境・各開発環境のコンテナが停止します
  // 「https://tokyoescort-otome.com/gateway」の削除またはURLを変更する場合は必ずサーバ担当者に相談すること
  export default {}
</script>